module.exports = {"title":"Hello, {{name}}","continue":"Continue to offer"}